import { FloatingLabel, Form } from 'react-bootstrap';

interface EditTimeProps {
  /** Floating label + placeholder. Omit to render a bare control (the caller supplies its own label, e.g. via `Field`). */
  readonly label?: string;
  readonly value: string | null;
  readonly onChange: (value: string | null) => void;
  readonly mandatory?: boolean;
}

/**
 * Time-of-day input wrapper. Renders `<input type="time">` (browser
 * native time picker). Returns `null` for an empty value, an HH:MM
 * string otherwise. The browser picker emits HH:MM (no seconds); the
 * backend accepts both HH:MM and HH:MM:SS shapes for `start_time`, so
 * the HH:MM output is fine. When `label` is omitted the bare control
 * renders and the caller owns the label.
 */
export const EditTime = ({ label, value, onChange, mandatory = false }: EditTimeProps) => {
  const control = (
    <Form.Control
      type="time"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
      placeholder={label}
      required={mandatory}
    />
  );
  return label ? <FloatingLabel label={mandatory ? `${label} *` : label}>{control}</FloatingLabel> : control;
};
